import React from 'react';
import { useModal } from '../hooks/useModal';
import { ShopifyModal } from './integration/ShopifyModal';
import { WooCommerceModal } from './integration/WooCommerceModal';

const channels = [
  {
    id: 'shopify',
    label: 'Shopify',
    icon: '/brandLogos/channel/shopify.svg',
    active: true,
  },
  {
    id: 'woo',
    label: 'Woocommerce',
    icon: '/brandLogos/channel/woocommerce.svg',
    active: true,
  },
  {
    id: 'amazon',
    label: 'Amazon',
    icon: '/brandLogos/channel/amazon.png',
    active: false,
  },
  {
    id: 'wix',
    label: 'Wix',
    icon: '/brandLogos/channel/wix.svg',
    active: false,
  },
  {
    id: 'opencart',
    label: 'Opencart',
    icon: '/brandLogos/channel/openCart.svg',
    active: false,
  },
  {
    id: 'magento',
    label: 'Magento',
    icon: '/brandLogos/channel/magento.svg',
    active: false,
  },
];

export const EcommerceChannels: React.FC = () => {
  const { open, close, Modal } = useModal();

  const handleIntegrate = (id: string) => {
    if (id === 'woo') {
      open({
        element: (
          <div className="p-2">
            <WooCommerceModal onClose={close} />
          </div>
        ),
        className: 'max-w-3xl w-[95vw]',
        closable: true,
      });
    } else if (id === 'shopify') {
      open({
        element: <ShopifyModal onClose={close} />,
        className: 'max-w-xl w-[95vw]',
        closable: true,
      });
    }
  };

  return (
    <div className="bg-card rounded-[16px] shadow-sm border p-8">
      <div className="border-b mb-6 pb-6">
        <h2 className="text-xl font-semibold mb-1">E-commerce Channels</h2>
        <p className="text-sm text-gray-600">
          Select and Connect channel on which your online store/website is
          built.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 xl:grid-cols-6 gap-6">
        {channels.map((channel) => (
          <div
            key={channel.id}
            className={`rounded-lg border border-gray-100 overflow-hidden  shadow-sm hover:shadow-md transition-all flex flex-col justify-between ${channel.active ? 'bg-white' : 'bg-gray-100 text-gray-400 cursor-not-allowed'}`}
          >
            <div className="flex flex-col items-center p-6 h-full justify-center">
              <div className="mb-5 flex h-16 w-16 items-center justify-center p-2 rounded-xl bg-gray-50/50">
                <img
                  src={channel.icon}
                  alt={channel.label}
                  className="max-h-full max-w-full object-contain mix-blend-multiply"
                />
              </div>

              <p className="font-semibold text-gray-800 text-base">
                {channel.label}
              </p>
            </div>

            <div
              onClick={() => channel.active && handleIntegrate(channel.id)}
              className={`p-4 text-center text-sm font-bold tracking-wide  transition-colors ${
                channel.active
                  ? 'bg-teal text-white cursor-pointer hover:bg-tealDark'
                  : 'bg-gray-100 text-gray-400 cursor-not-allowed'
              }`}
            >
              {channel.active ? 'Add' : 'Coming soon'}
            </div>
          </div>
        ))}
      </div>

      <Modal />
    </div>
  );
};
